"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const ButtonContainer_1 = require("../ButtonContainer");
const react_hanger_1 = require("react-hanger");
exports.EmailCanvasBlockContentConversionButton = ({ canRunConversions, conversionStatus, conversionsCount, setConversionStatus, conversionIsRunningOrHasRan, }) => {
    const prevCanRunConversions = react_hanger_1.usePrevious(canRunConversions);
    const start = react_1.useCallback(() => {
        setConversionStatus('loading');
    }, [setConversionStatus]);
    react_1.useEffect(() => {
        if (canRunConversions && !prevCanRunConversions) {
            start();
        }
    }, [canRunConversions !== prevCanRunConversions]);
    if (!canRunConversions || !conversionStatus) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const disabled = !!(!canRunConversions || conversionIsRunningOrHasRan);
    return (react_1.default.createElement(ButtonContainer_1.ButtonContainer, null,
        react_1.default.createElement(react_2.OsmosysButtonBlockToolbar, { osysName: "EmailCanvasBlockContentConversionButton", tooltip: conversionIsRunningOrHasRan
                ? undefined
                : `Run ${conversionsCount} conversion${conversionsCount === 1 ? '' : 's'}`, osysIcon: conversionStatus.error
                ? 'exclamation'
                : conversionStatus.success
                    ? 'success'
                    : conversionStatus.loading
                        ? 'spinner'
                        : 'convert', iconStyle: conversionIsRunningOrHasRan ? undefined : 'solid', iconSpin: conversionStatus.loading, disabled: disabled, onClick: () => {
                start();
            } }, conversionStatus.loading
            ? 'Converting...'
            : conversionStatus.success
                ? 'Converted'
                : conversionStatus.error
                    ? 'Failed to convert'
                    : 'Convert')));
};
//# sourceMappingURL=ContentConversionButton.js.map